import { customerFields } from './queries/customer-checkout'
export const CREATE_CUSTOMER = /* GraphQL */ `
    mutation createCustomer($input: CustomerInput! $increment_id: String!) {
        createCustomerOnCheckout(
            input: $input
            increment_id: $increment_id
        ) {
            customer {
                ${customerFields}
            }
        }
    }
`
